// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Yp1sM","containerItemsCenter":"Skeleton_containerItemsCenter__176WR"};